import { View } from "react-native";
import { Text } from "react-native-paper";
import { Chip as ChipStyled } from "./styled";

export default function Chip({ text }: { text: string }) {
  return (
    <View className="flex-row items-center justify-start">
      <ChipStyled className="bg-secondary rounded-2xl" textStyle="my-0.5">
        <Text className="text-white font-500">{text}</Text>
      </ChipStyled>
    </View>
  );
}
